 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		22: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		22: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"9650385fc6090fddf8622e29e4b8a1225092bec8","2":"styles","3":"0d048e63718a63a36f598fe6dea2b7e23d19f671","4":"ac5bb778532bef92268c0bd008c0e91141c324b3","5":"af476c6d69ffe5ed5b9a369355e5288bbdae6a1b","6":"daeed447f55135e7bd41a33df93e69286e68e511","7":"7e2aae26693e988f8a6bc99f0fa1a84b046b81c9","8":"2273aa0b9a9244612abd9fa48bd5792b4ff7b9cc","9":"24dfe8afacd8383e9992f5bae70368be2765591d","10":"d25cf26e114a12388e4a7a6f018ec59a003146a9","11":"371d8c3f2368b3e6ee06775f0a45069d3384fc34","12":"6fe37ed2bbe4012ea314c410baf07c53c2c33411","13":"27924b6e6dbba537a8b442f3e48ad52c15d61cf1","14":"1f734ee7e5e216a12bb9a6dc96cb97d32b52c4d6","15":"51425ddf9bab5e7bb172a2f7f06d3054e388fb63","16":"519e28ea6b04f1cf46624cf1f068dc35adbc21ba","17":"5d36f1350c334e44aadc90c06c8a32119c54f570","18":"8649d85790af916ea7f1c9b9268f3822d4c0f51c","19":"8b0065f14aa678c62dbed3739db157b24d0e1e97","20":"8e8994eeb7f1cfcebcc676af8a39dbb86f774f72","21":"cf79d9632318ca10b1d0795609480ba8014a6c38","24":"component---src-pages-404-js","25":"component---src-pages-activities-js","26":"component---src-pages-activity-detail-js","27":"component---src-pages-birthday-privileges-js","28":"component---src-pages-booking-confirmation-js","29":"component---src-pages-booking-details-js","30":"component---src-pages-booking-form-js","31":"component---src-pages-booking-list-cancelled-js","32":"component---src-pages-booking-list-expired-js","33":"component---src-pages-booking-list-js","34":"component---src-pages-booking-list-use-js","35":"component---src-pages-booking-list-used-js","36":"component---src-pages-booking-select-branch-js","37":"component---src-pages-booking-select-date-js","38":"component---src-pages-booking-select-time-js","39":"component---src-pages-booking-use-ref-code-js","40":"component---src-pages-favorite-js","41":"component---src-pages-index-js","42":"component---src-pages-more-js","43":"component---src-pages-package-package-list-js","44":"component---src-pages-package-privilege-group-list-js","45":"component---src-pages-package-privilege-list-js","46":"component---src-pages-page-2-js","47":"component---src-pages-privilege-detail-js","48":"component---src-pages-privilege-search-js","49":"component---src-pages-privileges-js","50":"component---src-pages-redeem-history-expired-js","51":"component---src-pages-redeem-history-js","52":"component---src-pages-redeem-history-suspended-js","53":"component---src-pages-redeem-history-use-js","54":"component---src-pages-redeem-history-used-js","55":"component---src-pages-redeem-select-branch-js","56":"component---src-pages-redeem-use-js","57":"component---src-pages-redeem-use-ref-code-js","58":"component---src-pages-status-banking-js","59":"component---src-pages-status-compare-tiers-js","60":"component---src-pages-status-financial-privilege-js","61":"component---src-pages-status-health-js","62":"component---src-pages-status-index-js","63":"component---src-pages-status-lifestyle-birthday-js","64":"component---src-pages-status-lifestyle-index-js","65":"component---src-pages-status-privilege-package-detail-js","66":"component---src-pages-status-term-and-condition-js","67":"component---src-pages-status-travel-airport-lounge-js","68":"component---src-pages-status-travel-index-js","69":"component---src-pages-status-travel-insurance-js","70":"component---src-pages-status-travel-k-point-klub-js","71":"component---src-pages-status-travel-priority-pass-js","72":"component---src-pages-status-wellness-js","73":"component---src-pages-using-typescript-tsx"}[chunkId]||chunkId) + "-" + {"0":"00adf98152e11bba745f","1":"0d6460592683331ac7ae","2":"2d82ac8e3afc0c213061","3":"d2cd921db71edac340a7","4":"c76c79141fe8e2fab55d","5":"73efb6314477b1fb9f49","6":"c21586871cb21b1b0b2d","7":"28254fad1bf8e7b1858f","8":"14af379d5ad6206252ce","9":"d4dd4eca7a1dc8e946c8","10":"f420c6750bf6c94394c9","11":"f7c182e48765c2982912","12":"82be7ee1991b3926c97d","13":"2df39d93ba9062260805","14":"cb0d11cad699d97671ff","15":"c6333a8613fa99521997","16":"c42a58f9f03770442c49","17":"db55a8179145812413cf","18":"ebe7b1a9fd1c8b400c21","19":"cef64503321f14f5dfa4","20":"51cd68316a7705fa45b1","21":"0394256ada79c061c7be","24":"6f664c34b9064cda9590","25":"2781bf7083ec577556e0","26":"cd88a84230348a7e256a","27":"bb7e52f555d5f067ab7a","28":"681fde46e5e069a89d98","29":"9aa66d30cca42ac4e025","30":"fed7686ee11b6fe081b6","31":"6c5e47335890baa808d4","32":"51f44ce2a398179f281f","33":"282cca5faba0df34ecbe","34":"fdefb04bbc3c0990af03","35":"76800f3dfb39a0c590dc","36":"a81aae9dc7c9f9c7bb97","37":"69ecfb31023e8f6b9695","38":"2d054349959c2fa31834","39":"8fb64a1ef19712c5cc31","40":"e33962df0f79e70bdde0","41":"117ac285f5dcf206d3e0","42":"05601898913afc28ca1f","43":"e1f901d83b230eb491e5","44":"24f96335952b0c6123ad","45":"940ea76a659c67522635","46":"7f4f2ac78f71b2657d13","47":"4bebbbe25564854de956","48":"3f7445240818f4688e80","49":"84b0f023e451bf5fca2f","50":"2a729f7f46069df8ba50","51":"00e2e55298f6e785bb35","52":"d112fbb54c983effa2ae","53":"e658456bb57edd8c65c9","54":"efcf2bb5f3d9810cd1d0","55":"d481da3b405b49f28773","56":"bd077b7919fc0e6902b6","57":"b2f761dcca7dbebf5d7d","58":"e6dd03c3d5e83aa3f0fa","59":"f324512e74add99a7666","60":"f6bb1d5d8f540f26549f","61":"0a4f3ad66e3991d2bcca","62":"0836876d005924f5b300","63":"31bca1059235d4cff9e0","64":"8f8a1386b0bb69d278a0","65":"7d2a3082edbab6a06b16","66":"cbc48d1fbde2482f2528","67":"23f3088937dd45fab128","68":"3d82818f2ef0d9ec5b2e","69":"3bf489efc2cb96e2be84","70":"cc1e80ffb32a5eaafb7b","71":"30bf853f81f586235f0b","72":"8e042792cd008f4cb3de","73":"5f01786c40f54ddc0ed3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"9650385fc6090fddf8622e29e4b8a1225092bec8","2":"styles","3":"0d048e63718a63a36f598fe6dea2b7e23d19f671","4":"ac5bb778532bef92268c0bd008c0e91141c324b3","5":"af476c6d69ffe5ed5b9a369355e5288bbdae6a1b","6":"daeed447f55135e7bd41a33df93e69286e68e511","7":"7e2aae26693e988f8a6bc99f0fa1a84b046b81c9","8":"2273aa0b9a9244612abd9fa48bd5792b4ff7b9cc","9":"24dfe8afacd8383e9992f5bae70368be2765591d","10":"d25cf26e114a12388e4a7a6f018ec59a003146a9","11":"371d8c3f2368b3e6ee06775f0a45069d3384fc34","12":"6fe37ed2bbe4012ea314c410baf07c53c2c33411","13":"27924b6e6dbba537a8b442f3e48ad52c15d61cf1","14":"1f734ee7e5e216a12bb9a6dc96cb97d32b52c4d6","15":"51425ddf9bab5e7bb172a2f7f06d3054e388fb63","16":"519e28ea6b04f1cf46624cf1f068dc35adbc21ba","17":"5d36f1350c334e44aadc90c06c8a32119c54f570","18":"8649d85790af916ea7f1c9b9268f3822d4c0f51c","19":"8b0065f14aa678c62dbed3739db157b24d0e1e97","20":"8e8994eeb7f1cfcebcc676af8a39dbb86f774f72","21":"cf79d9632318ca10b1d0795609480ba8014a6c38","24":"component---src-pages-404-js","25":"component---src-pages-activities-js","26":"component---src-pages-activity-detail-js","27":"component---src-pages-birthday-privileges-js","28":"component---src-pages-booking-confirmation-js","29":"component---src-pages-booking-details-js","30":"component---src-pages-booking-form-js","31":"component---src-pages-booking-list-cancelled-js","32":"component---src-pages-booking-list-expired-js","33":"component---src-pages-booking-list-js","34":"component---src-pages-booking-list-use-js","35":"component---src-pages-booking-list-used-js","36":"component---src-pages-booking-select-branch-js","37":"component---src-pages-booking-select-date-js","38":"component---src-pages-booking-select-time-js","39":"component---src-pages-booking-use-ref-code-js","40":"component---src-pages-favorite-js","41":"component---src-pages-index-js","42":"component---src-pages-more-js","43":"component---src-pages-package-package-list-js","44":"component---src-pages-package-privilege-group-list-js","45":"component---src-pages-package-privilege-list-js","46":"component---src-pages-page-2-js","47":"component---src-pages-privilege-detail-js","48":"component---src-pages-privilege-search-js","49":"component---src-pages-privileges-js","50":"component---src-pages-redeem-history-expired-js","51":"component---src-pages-redeem-history-js","52":"component---src-pages-redeem-history-suspended-js","53":"component---src-pages-redeem-history-use-js","54":"component---src-pages-redeem-history-used-js","55":"component---src-pages-redeem-select-branch-js","56":"component---src-pages-redeem-use-js","57":"component---src-pages-redeem-use-ref-code-js","58":"component---src-pages-status-banking-js","59":"component---src-pages-status-compare-tiers-js","60":"component---src-pages-status-financial-privilege-js","61":"component---src-pages-status-health-js","62":"component---src-pages-status-index-js","63":"component---src-pages-status-lifestyle-birthday-js","64":"component---src-pages-status-lifestyle-index-js","65":"component---src-pages-status-privilege-package-detail-js","66":"component---src-pages-status-term-and-condition-js","67":"component---src-pages-status-travel-airport-lounge-js","68":"component---src-pages-status-travel-index-js","69":"component---src-pages-status-travel-insurance-js","70":"component---src-pages-status-travel-k-point-klub-js","71":"component---src-pages-status-travel-priority-pass-js","72":"component---src-pages-status-wellness-js","73":"component---src-pages-using-typescript-tsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"0bc98aa00e83d626e148","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/wppapi/spa/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
